<div id="account-details-section">
  <span id="subtitle">Account details</span>
  <div id="resp-table">
    <div id="resp-table-body">
      <div class="resp-table-row">
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group id="accountDetails_accountType" [title]="labels.accountType"
                        [data]="regType">
          </mm-label-group>
        </div>
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'" *ngIf="taxId && !isReviewPage">
          <mm-label-group id="accountDetails_taxId" [title]="labels.taxId" [data]="taxId" data-testid="accountDetailsSection_taxId">
          </mm-label-group>
        </div>
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group id="accountDetails_accountNumber" [title]="labels.accountNumber"
                      [data]="accountNumber| hyphenated" data-testid="accountDetailsSection_accountId"></mm-label-group>
        </div>
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group id="accountDetails_masterAccount" [title]="labels.masterAccount"
                      [data]="masterAccount | hyphenated"></mm-label-group>
        </div>
      </div>
      <div class="resp-table-row">
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group id="accountDetails_accountHolder" [title]="labels.primaryAccountHolder"
                        [multilineData]="accountHolder">
        </mm-label-group>
        </div>
        <div *ngIf="displayAccountHolderId" [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group id="accountDetails_requestingAccountHolder"
                        [title]="labels.requestingAccountHolder"
                        [data]="requestingAccountHolderFullName | name">
        </mm-label-group>
        </div>
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group *ngIf="(isStandingAuthViewPage || isViewTemplate) && !isFromTableOrView && !!nickname" id="accountDetails_nickname"
            [title]="labels.nickname"
            [data]="nickname">
          </mm-label-group>
        </div>
      </div>
    </div>
  </div>
</div>
<hr id="bottom-divider">
